import * as R from 'ramda';
import { css } from '@emotion/core';
import { COLORS } from '../../globalStyle/colors';


export const BTN_DISABLED = css`
  &:disabled {
    opacity: .4;
    cursor: not-allowed;
  }
`;


export const BTN_HOVER = css`
  &:hover {
    background-color: ${COLORS.HOVER_GREY};
    color: ${COLORS.WHITE};
    border: 1px solid ${COLORS.HOVER_GREY};
    cursor: pointer;
  }
`;


export const BTN_GENERAL = css`
  box-sizing: border-box;
  font-size: 12px;
  text-align: center;
  text-decoration: none;
  border-radius: 8px;
  line-height: 34px;
  height: 35px;
  user-select: none; /* For links parading around as buttons -- no selecting that text! */
  transition: background-color .25s ease;
  padding: 0 12px;
  white-space: nowrap;
`;


export const BTN_SHIMMER = css`
  animation : shimmer 1.5s infinite;
  background-image: linear-gradient(
    45deg,
    transparent 0%,
    transparent 40%,
    rgba(255,255,255,0.01) 45%,
    rgba(255,255,255,0.35) 50%,
    rgba(255,255,255,0.01) 60%,
    transparent 65%,
    transparent 100%
  );
  background-size: 50% 60px;
  background-repeat: no-repeat;

  @keyframes shimmer {
    0% {
      background-position: -100% -10px;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;


export const btnStyle = {
  /**
   * Primary button, solid background, memoized
   */
  primary:   R.memoizeWith(
    (color?: string) => `${color}`,
    (color?: string) => css`
      background-color: ${color};
      border: 1px solid ${color};
      
      /* If the bg color is white, don't use white text */
      color: ${color === COLORS.WHITE ? COLORS.DARK_GREY : COLORS.WHITE};

      ${BTN_GENERAL};
      ${BTN_HOVER};
      ${BTN_DISABLED};
    `,
  ),

  /**
   * Secondary button, white background, border, memoized
   */
  secondary: R.memoizeWith(
    (color?: string) => `${color}`,
    (color?: string) => css`
      background-color: ${COLORS.WHITE};
      border: 1px solid ${color};
      color: ${color};

      ${BTN_GENERAL};
      ${BTN_HOVER};
      ${BTN_DISABLED};
    `,
  ),

  /**
   * tertiary button, white background, border, memoized
   */
  tertiary: R.memoizeWith(
    (color?: string) => `${color}`,
    (color?: string) => css`
      background-color: transparent;
      border: none;
      color: ${color};

      ${BTN_GENERAL};
      ${BTN_HOVER};
      ${BTN_DISABLED};
    `,
  ),

  /**
   * Transparent button, matching text and border, memoized
   */
  transparent: R.memoizeWith(
    (color?: string) => `${color}`,
    (color?: string) => css`
      background-color: transparent;
      border: 1px solid ${color};
      color: ${color};

      ${BTN_GENERAL};
      ${BTN_HOVER};
      ${BTN_DISABLED};
    `,
  ),

  /**
   * Use this for buttons where only the label should be visible (e.g., wherever there's an action icon in the UI)
   */
  invisible: css`
    outline: none;
    color: transparent;
    background-color: transparent;
    border: 0 none;
    padding: 0;
  `,
};
